<template>
  <div class="modify_wrapper">
    <!-- 上部 start-->
    <div class="info_top">
      <van-cell class="my_cell"><span class="title">保单信息</span></van-cell>
      <van-cell-group>
        <ModifyCell label="保险期间" content="“家政无忧”-标准计划" />
        <ModifyCell label="保单号码" content="8G201999202020202020" />
        <ModifyCell label="起保时间" content="2020.08.10-2021.08.09" />
        <ModifyCell label="产品保费" content="180元" />
        <ModifyCell label="保障计划" content="方案一" />
      </van-cell-group>
    </div>
    <ModuleTitle title="被保人信息（旧）" />
    <van-search
      v-model="searchValue"
      show-action
      shape="round"
      class="modify_search_input"
      placeholder="输入原被保人姓名"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch" class="search_btn">搜索</div>
      </template>
    </van-search>
    <div class="insured_title">被保人一</div>
    <van-cell-group>
      <ModifyCell label="姓名" content="“家政无忧”-标准计划" />
      <ModifyCell label="证件类型" content="身份证" />
      <ModifyCell label="证件号码" content="342221198710014069" />
      <ModifyCell label="性别" content="女" />
      <ModifyCell label="出生日期" content="1992-10-10" />
    </van-cell-group>
    <ModuleTitle title="被保人信息（新）" />
    <div class="insured_info">
      <div class="write_type_box">
        <div class="type">手动输入</div>
        <div class="type">身份证识别</div>
      </div>
      <InsuredInfoItem :insuredInfo="insuredInfo" />
    </div>
    <van-button class="btn_post" type="primary" size="large">提交</van-button>
  </div>
</template>

<script>
import './ModifyInsued.less'
import { Cell, CellGroup, Search, Button } from 'vant';
import ModifyCell from '../../components/ModifyCell/ModifyCell.vue'
import ModuleTitle from '../../components/ModuleTitle.vue'
import InsuredInfoItem from '@/components/InsuredInfoItem/InsuredInfoItem.vue'
export default {
  name: 'ModifyInsued',
  data() {
    return {
      searchValue: '',
      insuredInfo: {
        insuredName: '',
        insuredGender: 1,
        insuredCertificatTypes: [
          { id: 1, value: '身份证' },
          { id: 2, value: '军官证' },
          { id: 3, value: '护照' },
          { id: 4, value: '驾驶证' },
          { id: 5, value: '营业执照' },
          { id: 6, value: '其他' },
        ],
        insuredCertificat: '',
        insuredCertificatId: '',
        showInsuredCertificatPicker: false,
        insuredIdCardNum: '',
        showInsuredCalendar: false,
        birthday: ''
      }
    }
  },
  components: {
    'van-cell': Cell,
    'van-cell-group': CellGroup,
    'van-search': Search,
    'van-button': Button,
    ModifyCell,
    ModuleTitle,
    InsuredInfoItem
  },
  methods: {
    onSearch() {
      console.log('object')
    }
  }
}
</script>

<style>
</style>